import { FC } from 'react';
import styled from 'styled-components';
import { Dialog } from './Dialogs';
import { useZakeke } from '@zakeke/zakeke-configurator-react';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const ErrorDialog: FC<{ error: string; onCloseClick: () => void }> = ({ error, onCloseClick }) => {
	const { T_static } = useZakeke();
	return (
		<Dialog alignButtons='center' buttons={[{ label: T_static('Close'), onClick: onCloseClick }]}>
			<Container>
				<span>{error}</span>
			</Container>
		</Dialog>
	);
};

export default ErrorDialog;
